import { defineStore } from "pinia";

export const useVoskStore = defineStore('voskStore', {
  state : () => ({
    model : null,
    audioContext : null, 
    source : null,
    recognizer : null,
    recognizerProcessor : null,
    channel : null,
    isListening : true,
    microphoneBlockedAlertShown : false
  }),
  getters: {
    getVoskFields() {
      //console.log("************    get stored vosk fields",this.model,this.audioContext,this.source,this.recognizer)
      return { model : this.model, audioContext : this.audioContext, source : this.source, 
                        recognizer : this.recognizer,
                        recognizerProcessor : this.recognizerProcessor ,
                        channel : this.channel,
                        isListening : this.isListening}
    },
    getAlertShown() {
      return (this.microphoneBlockedAlertShown)
    }
  },
  actions: {
    updateStoredVoskFields(model, audioContext,source,recognizer,recognizerProcessor,channel) {
      //console.log("***** update stored vosk fields ",model, audioContext,source,recognizer)
      this.model = model
      this.audioContext = audioContext
      this.source = source
      this.recognizer = recognizer
      this.recognizerProcessor = recognizerProcessor
      this.channel = channel
    },
    updateIsListening(isListening) {
      this.isListening = isListening
    },
    updateAlertShow(shown) {
      this.microphoneBlockedAlertShown = shown
    }
  }

})
